let addNotificationHandler = null;

export const registerUiNotificationHandler = (handler) => {
  addNotificationHandler = handler;

  return () => {
    if (addNotificationHandler === handler) {
      addNotificationHandler = null;
    }
  };
};

export const showUiNotification = (notification) => {
  if (!addNotificationHandler) {
    return false;
  }

  addNotificationHandler(notification);

  return true;
};
